import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

export const getLandingPagesState = (state: NutshellState) => state.landingPages;

// Pages report
const getLandingPagesReportState = createSelector(
    [getLandingPagesState],
    (reportState) => reportState.landingPagesReport
);

const getLandingPagesChartState = createSelector(
    [getLandingPagesReportState],
    (landingPagesReport) => landingPagesReport.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getLandingPagesChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);
export const isChartTimedOut = createSelector(
    [getLandingPagesChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = (state: NutshellState) => getLandingPagesChartState(state).isErrored;

export const getCurrentReportChartData = createSelector(
    [getLandingPagesChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);

export const getCurrentReportChartBucketWithValuesCount = createSelector(
    [getCurrentReportChartData],
    (chartData) =>
        chartData
            ? chartData.buckets.filter(
                  // Filter out buckets with a zero value for Views
                  // @ts-expect-error
                  (bucket) =>
                      bucket.bucketData &&
                      bucket.bucketData.summary &&
                      bucket.bucketData.summary.segments &&
                      bucket.bucketData.summary.segments.Views &&
                      bucket.bucketData.summary.segments.Views.count
              ).length
            : 1
);

export const getSummaryStatsState = createSelector(
    [getLandingPagesState],
    (reportState) => reportState.summaryStats
);

export const getSummaryStatsIsLoading = createSelector(
    [getSummaryStatsState],
    (summaryStatsState) => {
        return summaryStatsState.isLoading;
    }
);

export const getLandingPagesTableData = createSelector(
    [getLandingPagesReportState],
    (landingPagesReport) => landingPagesReport.tableData
);

export const getLandingPagesTableDataHasError = createSelector(
    [getLandingPagesTableData],
    (landingPagesTableData) => landingPagesTableData.hasError
);

export const getLandingPagesTableRows = createSelector(
    [getLandingPagesTableData],
    (landingPagesTableData) => landingPagesTableData.rows
);

export const getLandingPagesTableTotals = createSelector(
    [getLandingPagesTableData],
    (landingPagesTableData) => landingPagesTableData.totals
);

export const getSummaryStatsStats = createSelector([getSummaryStatsState], (summaryStatsState) => {
    return summaryStatsState.stats;
});
